import {
  Box,
  CardHeader,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { Component } from "react";
import { Fade } from "react-reveal";
import EscaTokenomicsImg from "./../assests/images/EscaTokenomics.jpg";

export default class EscaToken extends Component {
  render() {
    return (
      <Box id="Esca Token" style={{ padding: "20px" }}>
        <Container>
          <Grid container gutterBottom spacing={3}>
            <Grid item xs={12} sm={6} className="my-auto">
              <div
                className="animated"
                data-animation="fadeInLeftShorter"
                data-animation-delay="0.5s"
              >
                <Fade top>
                  <CardHeader
                    title={
                      <Typography
                        className="text-left w-100"
                        component="h4"
                        variant="h4"
                      >
                        TOKENOMICS
                      </Typography>
                    }
                  />
                </Fade>
                <Fade left>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Typography component="p" variant="p">
                            {" "}
                            Hard cap (total number of tokens minted) 10 Million
                          </Typography>
                        }
                      ></ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Typography component="p" variant="p">
                            Circulating supply (token availability in year 1) 4
                            million{" "}
                          </Typography>
                        }
                      ></ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Typography component="p" variant="p">
                            {" "}
                            Presale prices $0.30 - $0.60 and Public sale price
                            $1
                          </Typography>
                        }
                      ></ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Typography component="p" variant="p">
                            {" "}
                            1% of the value of all sold tokens will be burned
                            per transaction. This reduces total supply therefore
                            increasing long term value. ​ A detailed breakdown
                            of our tokenomics, including cliffs and vesting
                            periods, are available on our{" "}
                            <a
                              alt="Esca Blogs"
                              href="https://www.escacrypto.com/post/our-tokenomics-are-changing"
                              target="_blank"
                            >
                              blog
                            </a>
                          </Typography>
                        }
                      ></ListItemText>
                    </ListItem>
                  </List>
                </Fade>
              </div>
            </Grid>
            <Grid className="my-auto" item xs={12} sm={6}>
              <div
                className="animated"
                data-animation="fadeInRightShorter"
                data-animation-delay="0.5s"
              >
                <div className="position-relative float-xl-right what-is-crypto-img">
                  <Fade right>
                    <img src={EscaTokenomicsImg} className="w-100" />
                  </Fade>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }
}
